// MF-67 — Read-only "what this entry inherits" panel, every piece NAMED and with its origin:
//   Category · Type (from the category) · Severity (from the template, or "Not applicable") · Points
//   (from the template). Staff see the level but can't overwrite it — to record a different one they
//   pick another template. `level` = { type, severity: { label, color } | null, severityApplies, points }.
import { Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ColorBadge, { Points, TypeBadge } from './ColorBadge'

const Cell = ({ label, from, children }) => (
  <div className='flex flex-col' style={{ gap: 4, minWidth: 0 }}>
    <span
      style={{
        fontSize: 11,
        fontWeight: 600,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        color: 'rgb(100, 116, 139)'
      }}
    >
      {label}
    </span>
    <div
      style={{ fontSize: 13, color: 'rgb(15, 23, 42)', minHeight: 24, display: 'flex', alignItems: 'center' }}
    >
      {children}
    </div>
    {from ? <span style={{ fontSize: 11, color: 'rgb(148, 163, 184)' }}>{from}</span> : null}
  </div>
)

const InheritedLevel = ({
  category,
  level,
  source = 'the template',
  emptyText = 'Choose a template to see its level.'
}) => (
  <div
    className='flex flex-col'
    style={{
      gap: 12,
      padding: '14px 16px',
      borderRadius: 10,
      background: 'rgb(248, 250, 252)',
      border: '1px dashed rgb(203, 213, 225)'
    }}
  >
    {level ? (
      <div className='grid' style={{ gap: 16, gridTemplateColumns: 'repeat(auto-fit, minmax(130px, 1fr))' }}>
        <Cell label='Category'>{category?.name || '—'}</Cell>
        <Cell label='Type' from='from the category'>
          <TypeBadge code={level.type || 'neutral'} />
        </Cell>
        <Cell label='Severity' from='from the template'>
          {level.severity ? (
            <ColorBadge label={level.severity.label} color={level.severity.color} size='sm' />
          ) : level.severityApplies ? (
            <span style={{ color: 'rgb(220, 38, 38)' }}>Not set</span>
          ) : (
            <span style={{ color: 'rgb(100, 116, 139)' }}>Not applicable</span>
          )}
        </Cell>
        <Cell label='Points' from='from the template'>
          <Points value={level.points ?? 0} />
        </Cell>
      </div>
    ) : (
      <Typography style={{ fontSize: 13, color: 'rgb(148, 163, 184)' }}>{emptyText}</Typography>
    )}
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        fontSize: 12,
        color: 'rgb(100, 116, 139)'
      }}
    >
      <FontAwesomeIcon icon={['fal', 'lock']} style={{ fontSize: 11 }} />
      Inherited from {source} — it can’t be changed here.
    </span>
  </div>
)

export default InheritedLevel
